"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariables = exports.TemplateType = void 0;
const offerLetter_1 = __importDefault(require("./templates/offerLetter"));
const offer_1 = __importDefault(require("./templates/offer"));
const offerConfirmation_1 = __importDefault(require("./templates/offerConfirmation"));
const packingMaterialDelivery_1 = __importDefault(require("./templates/packingMaterialDelivery"));
const packingMaterialPickup_1 = __importDefault(require("./templates/packingMaterialPickup"));
const workInstructions_1 = __importDefault(require("./templates/workInstructions"));
const feedbackLetter_1 = __importDefault(require("./templates/feedbackLetter"));
const workSlip_1 = __importDefault(require("./templates/workSlip"));
const invoice_1 = __importDefault(require("./templates/invoice"));
var TemplateType;
(function (TemplateType) {
    TemplateType["OfferLetter"] = "offerLetter";
    TemplateType["Offer"] = "offer";
    TemplateType["OfferConfirmation"] = "offerConfirmation";
    TemplateType["WorkInstructions"] = "workInstructions";
    TemplateType["PackingMaterialDelivery"] = "packingMaterialDelivery";
    TemplateType["PackingMaterialPickup"] = "packingMaterialPickup";
    TemplateType["FeedbackLetter"] = "feedbackLetter";
    TemplateType["Invoice"] = "invoice";
    TemplateType["WorkSlip"] = "workSlip";
})(TemplateType = exports.TemplateType || (exports.TemplateType = {}));
function getVariables(type, move, configuration, consultant, calculation, offer) {
    switch (type) {
        case TemplateType.OfferLetter:
            return offerLetter_1.default(move, configuration, consultant, calculation, offer);
        case TemplateType.Offer:
            return offer_1.default(move, calculation, offer);
        case TemplateType.OfferConfirmation:
            return offerConfirmation_1.default(move, consultant);
        case TemplateType.WorkInstructions:
            return workInstructions_1.default(move, configuration);
        case TemplateType.PackingMaterialDelivery:
            return packingMaterialDelivery_1.default(move, configuration);
        case TemplateType.PackingMaterialPickup:
            return packingMaterialPickup_1.default(move, configuration);
        case TemplateType.FeedbackLetter:
            return feedbackLetter_1.default(move, consultant);
        case TemplateType.WorkSlip:
            return workSlip_1.default(move, configuration);
        case TemplateType.Invoice:
            return invoice_1.default(move, configuration, offer);
        default:
            return {};
    }
}
exports.getVariables = getVariables;
//# sourceMappingURL=generateVariables.js.map